module.exports = __webpack_public_path__ + "img/foodpanda.9706234c.png";